angular.module('app').controller('AppCtrl', ['$scope', '$rootScope', '$state', function ($scope, $rootScope, $state) {
  $scope.app = {
    name: 'dealr.cloud Login',
    description: '',
    layout: {
      menuPin: false,
      menuBehind: false
    },
    author: 'Dealr, Inc.'
  };
  $scope.is = function (name) {
    return $state.is(name);
  };
  $scope.includes = function (name) {
    return $state.includes(name);
  };
  $scope.showSearchOverlay = function () {
    $scope.$broadcast('toggleSearchOverlay', {
      show: true
    });
  };
}]);
var secureComms = true;
if (location.protocol !== 'https:') {
  secureComms = false;
  console.log(secureComms);
}
app.config(['$cookiesProvider', function ($cookiesProvider) {
  $cookiesProvider.defaults.path = "/";
  $cookiesProvider.defaults.domain = window.location.hostname;
  if (window.location.protocol === 'https:') {
    $cookiesProvider.defaults.secure = true;
  }
}]).controller('SigninFormController', ["$scope", "$http", "$state", "$cookieStore", "$rootScope", "$document", "$cookies", "$window", "$routeParams", "$route", "$timeout", "$location", "$q", "dealrTabSync", "dealrAccount", function ($scope, $http, $state, $cookieStore, $rootScope, $document, $cookies, $window, $routeParams, $route, $timeout, $location, $q, dealrTabSync, dealrAccount) {
  var time = new Date().getTime() / 1000;
  $scope.user = {};
  $scope.newPass = {
    password: "",
    confirm_password: ""
  };
  $scope.authError = null;
  $scope.rebrand = !!($window.DEALR_FLAGS && $window.DEALR_FLAGS['release-dealr-rebrand']);
  $scope.accessApp = !!($window.DEALR_FLAGS && $window.DEALR_FLAGS['release-access']);
  if ($location.search().forDocumentation) {
    $scope.forDocumentation = true;
  }
  function isSameOriginTarget(url) {
    if (url.indexOf('/') === 0) {
      return url.indexOf('//') !== 0;
    }
    try {
      return new URL(url, $window.location.origin).origin === $window.location.origin;
    } catch (e) {
      return false;
    }
  }
  function applyUserPrefix(path, userId) {
    if (/^\/u\/[0-9]+\//.test(path)) {
      return path.replace(/^\/u\/[0-9]+\//, '/u/' + userId + '/');
    }
    if (path.indexOf('/') === 0) {
      return "/u/" + userId + path;
    }
    if (path.indexOf('/u/') > 0) {
      return path.replace(/\/u\/[0-9]+\//, '/u/' + userId + '/');
    }
    return path;
  }
  function resolveRedirectTarget(userId, type) {
    var redirUrl = $location.search().redirUrl;
    var fallback = "/u/" + userId + (type == "admin" ? "/admin/" : "/dealer/");
    if (!redirUrl || !isSameOriginTarget(redirUrl)) {
      return fallback;
    }
    var knownType = typeof type !== "undefined" && type !== null;
    if (knownType && type != "admin" && redirUrl.indexOf('/admin') !== -1) {
      return fallback;
    }
    return applyUserPrefix(redirUrl, userId);
  }
  function goToRedirectTarget(userId, type) {
    $window.location.href = resolveRedirectTarget(userId, type);
  }
  function goToLoginTarget(data, userId) {
    if (dealrAccount.core.loginEnrollmentRequired(data) && data.type != "admin") {
      $window.location.href = "/u/" + userId + "/dealer/user/settings";
      return;
    }
    if (data && data.identity_verification_blocked === true && data.type != "admin") {
      $window.location.href = "/u/" + userId + "/dealer/user/settings";
      return;
    }
    goToRedirectTarget(userId, data.type);
  }
  function parkedOnSignInForm() {
    return !$scope.page || $scope.page === 'login';
  }
  dealrTabSync.onLoginElsewhere(function (record) {
    if (!record || !record.userId) return;
    if ($scope.sendingLogin || $location.search().addAccount) return;
    if (!parkedOnSignInForm()) return;
    goToRedirectTarget(record.userId, record.type || undefined);
  });
  var rememberedUsername = dealrAccount.core.rememberedUsername($cookies.get('auth_username'), {
    addAccount: !!$location.search().addAccount
  });
  if (rememberedUsername !== null) {
    $scope.user.username = rememberedUsername;
    $timeout(function () {
      $scope.checkSaml();
    });
  }
  function cookieWriter(options) {
    return {
      put: function (name, value, expires) {
        $cookies.put(name, value, Object.assign({
          expires: expires
        }, options));
      }
    };
  }
  var sessionCookies = cookieWriter({
    secure: secureComms
  });
  var usernameCookie = cookieWriter({});
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    $document[0].cookie = cname + "=" + cvalue + "; " + expires;
  }
  var checkedSamlUsernames = {};
  var searchIndex = 0;
  var lastRequestCancel = $q.defer();
  $scope.checkSaml = function () {
    return new Promise(function (res, rej) {
      searchIndex++;
      var currentSearchIndex = searchIndex;
      lastRequestCancel.resolve();
      lastRequestCancel = $q.defer();
      if (!$scope.user.username) {
        $scope.saml = false;
        res($scope.saml);
      } else if (typeof checkedSamlUsernames[$scope.user.username] !== 'undefined') {
        $scope.saml = checkedSamlUsernames[$scope.user.username];
        res($scope.saml);
      } else {
        var username = angular.copy($scope.user.username);
        dealrAccount.api.loginLookup.samlDetails(username, {
          cancel: lastRequestCancel.promise
        }).then(function (data) {
          if ($location.search().redirUrl) {
            data.redirect = dealrAccount.core.samlStartUrl(data.redirect, $location.search().redirUrl);
          }
          checkedSamlUsernames[username] = data;
          if (currentSearchIndex != searchIndex) {
            console.log("cancelling result");
            return;
          }
          $scope.saml = checkedSamlUsernames[username];
          res($scope.saml);
        }, function (error) {
          if (dealrAccount.core.samlNotConfigured(error.status)) {
            checkedSamlUsernames[username] = false;
            $scope.saml = false;
          }
          res(false);
        });
      }
    });
  };
  $scope.samlLogin = function () {
    dealrAccount.presenter.rememberLoginUsername(usernameCookie, $scope.user.username, Date.now());
    window.open($scope.saml.redirect, '_self');
  };
  $scope.$watch("user.username", function () {
    $timeout(function () {
      $scope.checkSaml();
    });
  });
  $scope.selectAuthenticatedUser = function (token) {
    dealrAccount.api.loginLookup.checkAuth(token.token).then(function () {
      var decodedToken = jwt_decode(token.token);
      dealrTabSync.announceLogin({
        userId: decodedToken.uid,
        type: token.type
      });
      goToRedirectTarget(decodedToken.uid, token.type);
    }, function () {
      $scope.checkSaml().then(function (saml) {
        $scope.$apply(function () {
          if (saml && saml.required) {
            $scope.user.username = token.username;
            $scope.samlLogin();
          } else {
            $scope.page = 'login';
            $scope.user.username = token.username;
            $scope.user.authenticated_user = token;
          }
        });
      });
    });
  };
  $scope.removeAuthenticatedUser = function (key) {
    $scope.authenticatedUsers = $cookies.getObject("authenticated_users");
    delete $scope.authenticatedUsers[key];
    $cookies.putObject("authenticated_users", $scope.authenticatedUsers);
  };
  $scope.sendLogin = function (form) {
    if (form && form.$invalid || $scope.sendingLogin) {
      return;
    }
    if ($scope.page != 'verify' && $scope.saml && $scope.saml.required && checkedSamlUsernames[$scope.user.username] === $scope.saml) {
      $scope.samlLogin();
      return;
    }
    $scope.sendingLogin = true;
    dealrAccount.presenter.rememberLoginUsername(usernameCookie, $scope.user.username, Date.now());
    var sendingObject = {
      username: $scope.user.username,
      password: $scope.user.password
    };
    if ($scope.page == 'verify') {
      sendingObject.identity_code = $scope.user.identity_code;
    }
    $scope.authError = null;
    new Fingerprint2().get(function (result, components) {
      var existingDeviceToken = $cookies.get("device_token");
      if (typeof existingDeviceToken != "undefined") {
        sendingObject.fingerprint = existingDeviceToken;
      } else {
        sendingObject.fingerprint = result;
      }
      $q.when(dealrAccount.api.signIn.login(sendingObject)).then(function (data) {
        console.log(data);
        if (!data.token) {
          $scope.sendingLogin = false;
          if (data != "") {
            $scope.authError = data;
          } else {
            $scope.authError = 'The entered information is incorrect.';
          }
          $scope.user.password = "";
          $scope.user.identity_code = "";
        } else {
          completeLogin(data, sendingObject.fingerprint);
        }
      }, function (x) {
        $scope.sendingLogin = false;
        var mfaPending = dealrAccount.core.loginMfaPending(x.status, x.data);
        if (mfaPending) {
          startLoginMfa(mfaPending, sendingObject.fingerprint);
          return;
        }
        if (x.status == 403 && x.data && x.data.password_reset_required === true) {
          $scope.user.password = "";
          $scope.authError = x.data.error || 'For your security, you need to reset your password. Check your email for a reset link.';
          return;
        }
        if (x.status == 429) {
          $scope.authError = dealrAccount.errorMessage(x, 'Too many sign-in attempts. Try again in a minute.');
          return;
        }
        if (x.status == 401) {
          if (x.data != "") {
            $scope.authError = x.data;
          } else {
            $scope.authError = 'The entered information is incorrect.';
          }
          if ($scope.page != "verify") {
            $scope.user.password = "";
          }
          $scope.user.identity_code = "";
        } else if (x.status == 406) {
          $scope.page = 'verify';
          $scope.authError = x.data;
        } else if (x.status == 400 && x.data && x.data.options) {
          $scope.authError = x.data.type && (x.data.options.buttons || []).length ? '' : 'Unable to complete login. Please contact support.';
        } else {
          if (x.data != "") {
            $scope.authError = x.data;
          } else {
            $scope.authError = 'Server Error';
          }
        }
      });
    });
  };
  function completeLogin(data, fingerprint) {
    var handoff = {
      cookies: sessionCookies,
      now: function () {
        return Date.now();
      },
      later: function (fn, ms) {
        setTimeout(fn, ms);
      }
    };
    dealrAccount.presenter.handOffSession(handoff, data, fingerprint, function () {
      var decodedToken = jwt_decode(data.token);
      dealrTabSync.announceLogin({
        userId: decodedToken.uid,
        type: data.type
      });
      goToLoginTarget(data, decodedToken.uid);
    });
  }
  function startLoginMfa(pending, fingerprint) {
    var session = dealrAccount.presenter.createLoginMfaSession(dealrAccount.api.login, pending, dealrAccount.webauthn());
    $scope.user.password = "";
    $scope.authError = null;
    $scope.mfa = mfaState(session, {
      fingerprint: fingerprint
    });
    $scope.page = 'mfa';
    chooseFirstMfaMethod(session);
  }
  function mfaState(session, extra) {
    var core = dealrAccount.core;
    var rated = !!session.preferredMethod;
    var groups = rated ? core.groupMethodsByStrength(session.methods) : null;
    return Object.assign({
      session: session,
      methods: session.methods,
      strongMethods: groups ? groups.strong : null,
      weakMethods: groups ? groups.weak : null,
      backupMethod: session.backupMethod || null,
      canSwitch: session.methods.length + (session.backupMethod ? 1 : 0) > 1,
      method: null,
      needsCode: false,
      sent: false,
      code: "",
      busy: false
    }, extra);
  }
  function chooseFirstMfaMethod(session) {
    var lone = session.methods.length === 1 ? session.methods[0] : null;
    if (lone && (!session.backupMethod || dealrAccount.core.stepUpKind(lone.type) !== 'send-code')) {
      $scope.chooseMfaMethod(session.methods[0]);
    } else if (session.preferredMethod) {
      $scope.chooseMfaMethod(session.preferredMethod);
    } else if (!session.methods.length && session.backupMethod) {
      $scope.chooseMfaMethod(session.backupMethod);
    }
  }
  $scope.useBackupCode = function () {
    if ($scope.mfa && $scope.mfa.backupMethod) {
      $scope.chooseMfaMethod($scope.mfa.backupMethod);
    }
  };
  $scope.mfaIsBackupCode = function (method) {
    return dealrAccount.core.isBackupCodeMethod(method);
  };
  $scope.simSwapWarning = dealrAccount.core.SIM_SWAP_WARNING;
  $scope.mfaMethodName = function (method) {
    return dealrAccount.core.methodDisplayName(method);
  };
  $scope.mfaMethodType = function (method) {
    return dealrAccount.core.methodTypeLabel(method.type);
  };
  $scope.mfaPrompt = function (method) {
    return dealrAccount.core.stepUpPrompt(method);
  };
  function mfaFailed(error, fallback) {
    $scope.mfa.busy = false;
    if (error && error.cancelled) {
      $scope.authError = error.message;
      return;
    }
    $scope.authError = error && error.name === 'SecondFactorError' ? error.message : dealrAccount.errorMessage(error, fallback);
  }
  function finishMfa(mfa, data) {
    if (mfa.purpose === 'reset') {
      mfa.busy = false;
      $scope.mfa = null;
      $scope.page = 'changePass';
      if ($scope.newPass.password) $scope.sendChangePass();
      return;
    }
    completeLogin(data, mfa.fingerprint);
  }
  function resetVerificationApi(token) {
    function post(path, body) {
      return $q.when($http.post('/api/changePass/verification' + path, Object.assign({
        token: token
      }, body))).then(function (response) {
        return response.data;
      });
    }
    return {
      challenge: function (body) {
        return post('/mfa/challenge', {
          method_uuid: body.method_uuid
        });
      },
      verify: function (body) {
        var proof = Object.assign({}, body);
        delete proof.mfa_token;
        return post('/mfa/verify', proof);
      }
    };
  }
  $scope.startResetVerification = function () {
    var token = $scope.newPass.token;
    $scope.resetCheck = {
      loading: true
    };
    $q.when($http.post('/api/changePass/verification', {
      token: token
    })).then(function (response) {
      var data = response.data || {};
      $scope.resetCheck = {
        loading: false
      };
      var requirement = dealrAccount.core.resetRequirement(200, data);
      if (requirement.kind === 'contact_admin' || requirement.kind === 'identity_check') {
        $scope.resetCheck = {
          loading: false,
          blocked: requirement.kind === 'contact_admin' ? requirement.message : dealrAccount.core.identityProgress(requirement.status).message
        };
        $scope.page = 'resetBlocked';
      } else if (requirement.kind === 'mfa') {
        var pending = {
          mfaToken: token,
          methods: data.methods || []
        };
        if (data.method_strength) pending.methodStrength = data.method_strength;
        var session = dealrAccount.presenter.createLoginMfaSession(resetVerificationApi(token), pending, dealrAccount.webauthn());
        $scope.mfa = mfaState(session, {
          purpose: 'reset'
        });
        $scope.page = 'mfa';
        chooseFirstMfaMethod(session);
      }
    }, function (error) {
      $scope.resetCheck = {
        loading: false
      };
      if (error && error.status !== 404) {
        $scope.authError = dealrAccount.errorMessage(error, 'This reset link is no longer valid.');
      }
    });
  };
  $scope.chooseMfaMethod = function (method) {
    var mfa = $scope.mfa;
    if (!mfa || mfa.busy) return;
    mfa.method = method;
    mfa.needsCode = false;
    mfa.sent = false;
    mfa.code = "";
    mfa.busy = true;
    $scope.authError = null;
    $q.when(mfa.session.choose(method)).then(function (result) {
      mfa.busy = false;
      if (result.done) {
        finishMfa(mfa, result.done);
        return;
      }
      mfa.needsCode = true;
      mfa.sent = result.step.sent;
    }, function (error) {
      mfaFailed(error, 'We could not start that verification method. Try another one.');
    });
  };
  $scope.submitMfaCode = function (form) {
    var mfa = $scope.mfa;
    if (!mfa || !mfa.method || mfa.busy || form && form.$invalid) return;
    mfa.busy = true;
    $scope.authError = null;
    $q.when(mfa.session.submitCode(mfa.method, mfa.code)).then(function (data) {
      if (mfa.purpose === 'reset' && data && data.success) {
        finishMfa(mfa, data);
        return;
      }
      if (!data || !data.token) {
        mfa.busy = false;
        $scope.authError = 'That code did not work. Try again.';
        return;
      }
      completeLogin(data, mfa.fingerprint);
    }, function (error) {
      mfa.code = "";
      mfaFailed(error, 'That code did not work. Try again.');
    });
  };
  $scope.chooseAnotherMfaMethod = function () {
    if (!$scope.mfa || $scope.mfa.busy) return;
    $scope.mfa.method = null;
    $scope.mfa.needsCode = false;
    $scope.mfa.code = "";
    $scope.authError = null;
  };
  $scope.sendChangePass = function () {
    new Fingerprint2().get(function (result, components) {
      var existingDeviceToken = $cookies.get("device_token");
      if (typeof existingDeviceToken != "undefined" && $scope.page != "verify") {
        $scope.newPass.fingerprint = existingDeviceToken;
      } else {
        $scope.newPass.fingerprint = result;
      }
      $scope.sendingLogin = true;
      $http({
        method: "POST",
        url: '/api/changePass',
        data: angular.toJson($scope.newPass)
      }).success(function (data, status, headers, config) {
        if (data && data.sign_in_required === true) {
          alert("Your password has been reset. Sign in to continue.");
          $scope.sendingLogin = false;
          $scope.page = 'login';
          return;
        }
        if (typeof data.token != "undefined") {
          alert("Your password has been reset successfully.");
          $scope.sendingLogin = false;
          dealrAccount.presenter.writeSessionCookie(sessionCookies, data, Date.now());
          var decodedToken = jwt_decode(data.token);
          setTimeout(function () {
            dealrTabSync.announceLogin({
              userId: decodedToken.uid,
              type: data.type
            });
            $window.location.href = "/u/" + decodedToken.uid + (data.type == "admin" ? "/admin/" : "/dealer/");
          }, dealrAccount.core.SESSION_HANDOFF_DELAY_MS);
        }
      }).error(function (data, status, headers, config) {
        $scope.sendingLogin = false;
        if (status == 403 && data && data.verification_required === true) {
          $scope.startResetVerification();
          return;
        }
        $scope.authError = data;
      });
    });
  };
  $scope.forgot = {
    usernameEmail: "",
    passwordUsername: ""
  };
  $scope.loginForgotPassword = function () {
    $scope.page = "forgotPassword";
  };
  $scope.loginForgotUsername = function () {
    $scope.page = "forgotUsername";
  };
  $scope.backToLogin = function () {
    $scope.mfa = null;
    $scope.page = 'login';
  };
  $scope.backToAuthenticatedUserList = function () {
    $scope.page = 'existingUsers';
    $scope.user.authenticated_user = undefined;
  };
  $scope.forgotUsername = function () {
    $scope.sendingLogin = true;
    dealrAccount.api.resetLink.emailUsername($scope.forgot.usernameEmail).then(function (data) {
      $scope.sendingLogin = false;
      $scope.authError = data;
      $scope.backToLogin();
      $scope.forgot.usernameEmail = "";
      $scope.forgot.passwordUsername = "";
    }, function (error) {
      $scope.sendingLogin = false;
      if (error.status == 403 && error.data && error.data.verification_required === true) {
        $scope.startResetVerification();
        return;
      }
      $scope.authError = error.data;
    });
  };
  $scope.forgotPassword = function () {
    $scope.sendingLogin = true;
    dealrAccount.api.resetLink.requestLink($scope.forgot.passwordUsername).then(function (data) {
      $scope.sendingLogin = false;
      $scope.authError = data;
      $scope.backToLogin();
      $scope.forgot.usernameEmail = "";
      $scope.forgot.passwordUsername = "";
    }, function (error) {
      $scope.sendingLogin = false;
      if (error.status == 403 && error.data && error.data.verification_required === true) {
        $scope.startResetVerification();
        return;
      }
      if (error.status == 429) {
        $scope.authError = dealrAccount.errorMessage(error, 'Too many sign-in attempts. Try again in a minute.');
        return;
      }
      $scope.authError = error.data;
    });
  };
  $scope.init = function () {
    if (typeof $state.params.token != "undefined") {
      $rootScope.token = $state.params.token;
      $location.search('token', null);
    } else if (typeof $rootScope.token != "undefined") {
      $scope.newPass.token = $rootScope.token;
      $scope.page = 'changePass';
    } else {
      $scope.authenticatedUsers = $cookies.getObject("authenticated_users");
      if ($location.search().selectedUserId) {
        var selectedUserId = $location.search().selectedUserId;
        if ($scope.authenticatedUsers && typeof $scope.authenticatedUsers[selectedUserId] != "undefined") {
          $scope.selectAuthenticatedUser($scope.authenticatedUsers[selectedUserId]);
        } else {
          $location.search('selectedUserId', null);
        }
        return;
      }
      if (dealrAccount.core.opensAccountPicker($scope.authenticatedUsers ? Object.keys($scope.authenticatedUsers).length : 0)) {
        $scope.page = 'existingUsers';
        return;
      } else {
        $scope.page = 'login';
      }
      var addAccount = $location.search().addAccount;
      var token = $cookies.getObject("auth");
      if (typeof token != "undefined" && !addAccount) {
        dealrAccount.api.loginLookup.checkAuth(token.token).then(function () {
          var decodedToken = jwt_decode(token.token);
          goToRedirectTarget(decodedToken.uid, token.type);
        }, function () {
          $cookies.remove("auth");
          var domains = ["manage.dealr.cloud", ".manage.dealr.cloud", "staging.dealr.cloud", ".staging.dealr.cloud", "qa.engineering.dealr.cloud", ".qa.engineering.dealr.cloud", "dealr.cloud", ".dealr.cloud"];
          for (var i = 0; i < domains.length; i++) {
            $cookies.remove("auth", {
              domain: domains[i]
            });
          }
          document.cookie = "auth=; Max-Age=-99999999;";
        });
      }
    }
  };
  var domains = ["manage.dealr.cloud", ".manage.dealr.cloud", "staging.dealr.cloud", ".staging.dealr.cloud"];
  for (var i = 0; i < domains.length; i++) {
    $cookies.remove("auth", {
      domain: domains[i]
    });
  }
  $timeout(function () {
    $scope.init();
  }, 50);
  $scope.errors = {
    tooShort: true,
    needsNumber: true,
    needsLetter: true,
    needsSpecialChar: true,
    needsCap: true
  };
  $scope.passwordIsntStrong = true;
  $scope.addAccount = function () {
    $scope.user.username = '';
    $scope.saml = false;
    $scope.page = 'login';
  };
  $scope.checkPassStrength = function () {
    $scope.errors = dealrAccount.core.passwordStrength($scope.newPass.password);
    $scope.passwordIsntStrong = !dealrAccount.core.isPasswordStrong($scope.newPass.password);
  };
  var v1 = true;
  $scope.$watch("newPass.password", function () {
    if (v1 == true) {
      v1 = false;
    } else {
      $scope.checkPassStrength();
    }
  });
}]).controller("referralController", ["$scope", "$cookies", function ($scope, $cookies) {
  $scope.getReferralCookie = function () {
    $scope.referralCookie = $cookies.get("rt");
  };
  $scope.copyReferralLink = function () {
    var referralLink = document.querySelector('.referral-link');
    referralLink.select();
    referralLink.setSelectionRange(0, 99999);
    document.execCommand('copy');
    document.querySelector('.referral-copy-btn').innerHTML = '&#x2713;';
  };
  $scope.getReferralCookie();
}]).filter('decodeUriComponent', function () {
  return function (value) {
    return decodeURIComponent(value);
  };
}).directive('includeReplace', function () {
  return {
    require: 'ngInclude',
    restrict: 'A',
    link: function (scope, el, attrs) {
      el.replaceWith(el.children());
    }
  };
});